var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the_header",attrs:{"id":"element"}},[_c('div',{staticClass:"yoyo"},[_c('div',{staticClass:"hero-body w-full"},[_c('baniere'),_c('session2'),_c('session1'),_c('session3'),_c('session4'),_c('session5')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }